export const getRectCenterPoint = (rect) => {
  return {
    top: Math.round(rect.top + window.scrollY + rect.height / 2),
    left: Math.round(rect.left + rect.width / 2),
  };
};
